// extracted by mini-css-extract-plugin
module.exports = {"icon":"_1OM-UiXT1Vd5CPMiutr-fS"};